const intlFormatter = (label, currency, noMax = false, locale = 'en-US') => {
  const options = {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    compactDisplay: 'short',
    notation: 'compact',
    maximumSignificantDigits: 2,
  };

  if (noMax) {
    delete options.notation;
    delete options.maximumSignificantDigits;
  }

  const formatted = Number.isNaN(label)
    ? label
    : new Intl.NumberFormat(locale, options).format(label);
  // if no symbol, Intl returns the ISO code which we are already displaying as the label
  // so we need to strip that out
  return formatted.replace(currency, '').trim();
};

export default intlFormatter;
